import React from 'react'

interface EmailIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string
}

const EmailIcon: React.FC<EmailIconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 26 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23 0H3C1.625 0 0.5125 1.125 0.5125 2.5L0.5 17.5C0.5 18.875 1.625 20 3 20H23C24.375 20 25.5 18.875 25.5 17.5V2.5C25.5 1.125 24.375 0 23 0ZM22.5 5.3125L13.6625 10.8375C13.2625 11.0875 12.7375 11.0875 12.3375 10.8375L3.5 5.3125C3.1875 5.1125 3 4.775 3 4.4125C3 3.575 3.9125 3.075 4.625 3.5125L13 8.75L21.375 3.5125C22.0875 3.075 23 3.575 23 4.4125C23 4.775 22.8125 5.1125 22.5 5.3125Z"
      />
    </svg>
  )
}

export default EmailIcon
